import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { environment } from '../environments/environment';
import { Constants } from './constants';

@Injectable()
export class Helper {
  biAPI = this.getBiApi().split('/api')[0];

  constructor() {}

  getApi() {
    return environment.apiUrl;
  }

  getBiApi() {
    return environment.apiUrlBI;
  }

  getDomain() {
    return environment.domain;
  }

  getStorage(variable) {
    return JSON.parse(localStorage.getItem(variable));
  }
  

  validateCpr(cprData) {
    var cpr = require('danish-ssn');
    
    if (cprData.length === 10) {
      return cpr.isValid(cprData);
    }
  }

  getInsurance() {
    return Constants.INSURANCES.sort((a, b) =>
      a.value !== b.value ? (a.value < b.value ? -1 : 1) : 0
    );
  }

  getBookingData(clinic: string, complimentaId: string) {
    return {
      client: complimentaId,
      clinic: clinic,
      from: '2019-01-01 00:00:00', // get bookings from this date
      to: '2500-01-01 00:00:00', // get bookings up to this date
      activePage: 0,
      bookingsToShow: 50,
    };
  }

  exportPDF(bookingData: any) {
    const data = {
      id: bookingData.booking,
      therapist: bookingData.therapistData.name,
      clinic: bookingData.clinicData.name,
      address: bookingData.clinicData.address,
      city: bookingData.clinicData.city,
      post_code: bookingData.clinicData.post_code,
      type: bookingData.comment.behandling,
      insurance: bookingData.comment.insurance,
      body_parts: bookingData.comment.bodyparts,
      date_time: bookingData.dateHeader,
    };

    window.open(
      this.biAPI + '/export?booking=' + JSON.stringify(data),
      '_blank'
    );
  }

  getToken() {
    let token = '';

    const data_json = localStorage.getItem('currentUser');

    if (data_json) {
      const data = JSON.parse(data_json);

      token = data.token;
    }

    return token;
  }

  buildAuthHeader() {
    const headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: this.getToken(),
    });

    return new RequestOptions({ headers: headers });
  }

  isLoggedIn(): boolean {
    return Boolean(localStorage.getItem('currentUser'));
  }

  cancelPeriod(bookingTime, currentTime, booking) {
    if (booking.clinicData.cancelation_period) {
      const cancPeriodType = booking.clinicData.cancelation_period.type;

      if (cancPeriodType === 'hours') {
        const cancPeriodHours = booking.clinicData.cancelation_period.value;

        bookingTime.setHours(bookingTime.getHours() - cancPeriodHours);
      } else if (cancPeriodType === 'days') {
        const cancPeriodDays = booking.clinicData.cancelation_period.value_days;
        const cancPeriodTime = parseInt(
          booking.clinicData.cancelation_period.value_daytime
        );

        bookingTime.setDate(bookingTime.getDate() - cancPeriodDays);
        !isNaN(cancPeriodTime) ? bookingTime.setHours(cancPeriodTime) : null;
        bookingTime.setMinutes(0);
      }
      
      if (currentTime < bookingTime) {
        return true;
      } else {
        return false;
      }
    }
  }

  reformatDate(from_date) {
    // Safari and IE don't support the YYYY-MM-DD format, so it's 
    const fromDate = from_date.split(' ')[0].replace(/-/g, '/');
    const fromTime = from_date.split(' ')[1];
    
    return new Date(fromDate + ' ' + fromTime);
  }
}



// WEBPACK FOOTER //
// ./src/app/helper.ts